import ENDPOINT from "@/config/endpoint";
import request from "@/utils/request";

export async function fetchCategory(params) {
  return await request({
    url: ENDPOINT.CATEGORY,
    method: "get",
    params,
  });
}

export async function fetchAllCategory(params) {
  return await request({
    url: `${ENDPOINT.BACKEND_URL}/admin/get-all-category`,
    method: "get",
    params,
  });
}

export async function fetchById(id) {
  return await request({
    url: `${ENDPOINT.CATEGORY}/${id}`,
    method: "get",
  });
}

export async function createCategory(data) {
  return await request({
    url: ENDPOINT.CATEGORY,
    method: "post",
    data,
  });
}

export async function updateCategory(id, data) {
  return await request({
    url: `${ENDPOINT.CATEGORY}/${id}`,
    method: "post",
    data,
  });
}

export async function removeCategory(id) {
  return await request({
    url: `${ENDPOINT.CATEGORY}/${id}`,
    method: "delete",
  });
}